import React, { useMemo, useState, useEffect } from "react";

const LogoMark = () => (
  <div className="flex items-center gap-2">
    <div className="flex h-9 w-9 items-center justify-center rounded-md bg-[#14b85a] text-white text-base font-bold">
      B
    </div>
    <span className="text-[20px] font-extrabold text-[#14b85a]">BUY iT</span>
  </div>
);

const PendingIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="9" stroke="#111" strokeWidth="1.6" />
    <path d="M12 7v5l3 2" stroke="#111" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const UserIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="8" r="4" stroke="#111" strokeWidth="1.6" />
    <path d="M5 20c1.8-3 5-5 7-5s5.2 2 7 5" stroke="#111" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

const BikeIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="6" cy="17" r="3" stroke="#111" strokeWidth="1.6" />
    <circle cx="18" cy="17" r="3" stroke="#111" strokeWidth="1.6" />
    <path d="M9 17h4l3-6h-4l-2-4H6" stroke="#111" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9 17l3-6" stroke="#111" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

const MoreIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="5" cy="12" r="2" fill="#111" />
    <circle cx="12" cy="12" r="2" fill="#111" />
    <circle cx="19" cy="12" r="2" fill="#111" />
  </svg>
);

const TopBar = () => (
  <div className="flex items-center justify-between border-b border-gray-200 bg-[#f3f4f4] px-6 py-4">
    <LogoMark />
    <div className="flex items-center gap-3">
      <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[#14b85a] text-sm font-semibold text-white">
        J
      </div>
      <div className="text-right">
        <p className="text-sm font-semibold text-[#0b0b0b]">Good Afternoon, Jeff</p>
        <p className="text-xs text-gray-600">Admin</p>
      </div>
    </div>
  </div>
);

const AllIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="4" y="4" width="7" height="7" rx="1" stroke="#111" strokeWidth="1.6" />
    <rect x="13" y="4" width="7" height="7" rx="1" stroke="#111" strokeWidth="1.6" />
    <rect x="4" y="13" width="7" height="7" rx="1" stroke="#111" strokeWidth="1.6" />
    <rect x="13" y="13" width="7" height="7" rx="1" stroke="#111" strokeWidth="1.6" />
  </svg>
);

const SideNav = ({ activeTab, setActiveTab }) => {
  const items = [
    { label: "Pending", icon: <PendingIcon /> },
    { label: "Approved", icon: <UserIcon /> },
    { label: "Declined", icon: <BikeIcon /> },
    { label: "All", icon: <AllIcon /> },
    { label: "More", icon: <MoreIcon /> },
  ];

  return (
    <nav className="flex w-64 flex-col gap-2 bg-[#f3f4f4] px-4 py-6">
      {items.map((item, index) => {
        const isActive = activeTab === item.label;
        return (
          <div
            key={item.label}
            onClick={() => {
              if (item.label === "More") return;
              setActiveTab(item.label);
            }}
            className={`flex items-center gap-3 rounded-lg px-4 py-3 text-sm font-semibold transition ${
              isActive
                ? "bg-white text-[#14b85a] shadow-sm"
                : "text-[#0b0b0b] hover:bg-white"
            }`}
          >
            <span>{item.icon}</span>
            <span>{item.label}</span>
          </div>
        );
      })}
    </nav>
  );
};

const VendorTable = ({ vendors, onSelect }) => {
  if (!vendors.length) {
    return (
      <div className="rounded-lg bg-white p-8 text-center text-sm text-gray-600 shadow-sm">
        No vendors in this section.
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-lg bg-white shadow-sm">
      <table className="min-w-full text-left text-sm">
        <thead className="bg-[#f3f4f4] text-xs font-semibold uppercase text-gray-600">
          <tr>
            <th className="px-4 py-3">Name</th>
            <th className="px-4 py-3">Email</th>
            <th className="px-4 py-3">NIN</th>
            <th className="px-4 py-3">Phone NO</th>
            <th className="px-4 py-3">Action</th>
          </tr>
        </thead>
        <tbody>
          {vendors.map((vendor) => (
            <tr
              key={vendor.id}
              className="border-t border-gray-100 cursor-pointer hover:bg-gray-50"
              onClick={() => onSelect?.(vendor)}
            >
              <td className="px-4 py-3 font-medium text-[#0b0b0b]">
                {vendor.name}
                <span
                  className={`ml-2 rounded-full px-2 py-0.5 text-xs font-semibold ${
                    vendor.status === "Approved"
                      ? "bg-green-50 text-[#14b85a]"
                      : vendor.status === "Declined"
                      ? "bg-red-50 text-red-600"
                      : "bg-yellow-50 text-yellow-700"
                  }`}
                >
                  {vendor.status}
                </span>
              </td>
              <td className="px-4 py-3 text-gray-700">{vendor.email}</td>
              <td className="px-4 py-3 text-gray-700">{vendor.nin}</td>
              <td className="px-4 py-3 text-gray-700">{vendor.phone}</td>
              <td className="px-4 py-3">
                <button
                  type="button"
                  className="rounded-md border border-[#14b85a] px-3 py-1 text-xs font-semibold text-[#14b85a] hover:bg-[#14b85a] hover:text-white"
                  onClick={(e) => {
                    e.stopPropagation();
                    onSelect?.(vendor);
                  }}
                >
                  View
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const VendorSectionScreen = () => {
  const [activeTab, setActiveTab] = useState("Pending");
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const endpoint = useMemo(() => {
    if (activeTab === "Pending") return `${process.env.REACT_APP_API_URL}/api/admin/vendors/pending`;
    if (activeTab === "Approved") return `${process.env.REACT_APP_API_URL}/api/admin/vendors/approved`;
    if (activeTab === "Declined") return `${process.env.REACT_APP_API_URL}/api/admin/vendors/declined`;
    return "";
  }, [activeTab]);

  useEffect(() => {
    if (!endpoint) {
      setVendors([]);
      setError("");
      return;
    }
    const fetchVendors = async () => {
      setLoading(true);
      setError("");
      try {
        const token = localStorage.getItem("adminToken");
        const res = await fetch(endpoint, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        const data = await res.json();
        if (!data.success) {
          throw new Error(data.message || "Failed to load vendors");
        }
        const normalized = (data.data || []).map((vendor) => ({
          id: vendor._id,
          name: vendor.fullName,
          email: vendor.email,
          nin: vendor.nin || "N/A",
          phone: vendor.phoneNumber,
          status:
            vendor.status === "approved"
              ? "Approved"
              : vendor.status === "declined"
              ? "Declined"
              : "Pending",
        }));
        setVendors(normalized);
      } catch (err) {
        setError(err.message);
        setVendors([]);
      } finally {
        setLoading(false);
      }
    };

    fetchVendors();
  }, [endpoint]);

  return (
    <div className="min-h-screen w-full overflow-x-auto bg-[#f3f4f4] text-[#0b0b0b]">
      <div className="min-h-screen min-w-[600px]">
        <TopBar />
        <div className="flex">
          <SideNav activeTab={activeTab} setActiveTab={setActiveTab} />
          <main className="flex-1 px-6 py-6">
            <div className="mb-4">
              <h1 className="text-xl font-semibold text-[#0b0b0b]">BUY iT Vendor Section</h1>
              <p className="mt-1 text-sm text-gray-600">Review and manage vendors in this section.</p>
            </div>
            {loading ? (
              <div className="rounded-lg bg-white p-8 text-center text-sm text-gray-600 shadow-sm">
                Loading vendors...
              </div>
            ) : error ? (
              <div className="rounded-lg bg-white p-8 text-center text-sm text-red-600 shadow-sm">
                {error}
              </div>
            ) : (
              <VendorTable
                vendors={vendors}
                onSelect={(vendor) => {
                  if (!vendor?.id) return;
                  window.location.href = `/vendor-details/${vendor.id}`;
                }}
              />
            )}
          </main>
        </div>
      </div>
    </div>
  );
};

export default VendorSectionScreen;
